import { Component, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SharedFacade,
  ProjectsFacade,
  customEncode,
  customDecode,
  encrypt,
  decrypt,
  customEncrypt,
  customDecrypt,
} from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { GridIconComponent } from 'libs/ui/src/lib/grid-icon/grid-icon.component';
import { ProductIngredientDataGridService } from './product-ingredient-data-grid.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Subscription } from 'rxjs';
import { backToDashboardStr } from 'libs/shared/src/lib/constants';
import { AccessPermissionService, SwalService } from '@piqet-angular/shared';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
@Component({
  selector: 'piqet-angular-product-ingredients',
  templateUrl: './product-ingredients.component.html',
  styleUrls: ['./product-ingredients.component.scss'],
})
export class ProductIngredientsComponent implements OnDestroy {
  columnDefs: ColDef[];
  activatedRouteProjectId: any;
  projectPackConversionDataPayload: any;
  activatedRoute: any;
  gridName: string = 'Product ingredient List';
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  backBtnLabel: string = '';
  searchData: any = '';
  sortColumnState: any;
  productId: any;
  activeProductProjectId: any;
  headerData = {
    materialName: 'Summary of product ingredients',
  };
  event: any;
  menuDataForRouting: any;
  nextRouteName: any;
  productConfigId: any;
  editPopUpOpen!: Subscription;
  showEdit: boolean = false;

  constructor(
    private productIngredientDataGridService: ProductIngredientDataGridService,
    public sharedFacade: SharedFacade,
    public projectFacade: ProjectsFacade,
    public route: ActivatedRoute,
    private router: Router,
    private sharedService: SharedService,
    private accessService: AccessPermissionService,
    private reportsService: ReportsService,
    private swalService: SwalService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;

    this.route.queryParams.subscribe((values: any) => {
      this.projectPackConversionDataPayload = this.productIngredientDataGridService.getPayload(
        this.searchData
      );
      const url = location.href.split('/');
      this.productConfigId = Number(atob(decodeURIComponent(customDecode(url[6]))));
      const productId = customDecrypt(this.route.snapshot.queryParams['param']);
      this.productId = Number(productId.id);
      this.projectPackConversionDataPayload['draw'] = 1;
      this.projectPackConversionDataPayload['start'] = 0;
      this.projectFacade.getProductIngredientList(
        this.productId,
        this.projectPackConversionDataPayload
      );
    });

    this.columnDefs = this.productIngredientDataGridService.productIngredientDataColumn();

    this.sharedService.productProjectMenuArrData$.subscribe((res: any) => {
      if (res?.length) {
        this.menuDataForRouting = res.flatMap((product: any) =>
          product.submenu.map((scope: any) => ({
            ...scope,
            productId: product.productId,
            productName: product.name,
          }))
        );
      }
    });
  }
  ngOnDestroy(): void {
    this.editPopUpOpen.unsubscribe();
  }

  ngOnInit() {
    this.triggerScroll();
    this.showEdit = this.accessService.hasPermission('edit', '');
    this.editPopUpOpen = this.productIngredientDataGridService.editPopupOpenData$.subscribe(
      (data: any) => {
        this.addIngredientModal(data);
      }
    );
    this.findNextRoute();
  }

  triggerScroll(): void {
    this.sharedService.triggerScroll();
  }

  addIngredientModal(id: any) {
    this.projectFacade.openModalProductIngredient(
      this.productId,
      id || 0,
      'Add product manufacturing process to make 1kg/litre of product',
      this.activatedRoute
    );
  }
  paginationChanged(event: any) {
    this.event = event;
    this.projectPackConversionDataPayload = this.productIngredientDataGridService.getPayload(
      this.searchData,
      this.sortColumnState,
      event
    );
    this.sharedFacade.clearSearch(false);
    this.projectFacade.getProductIngredientList(
      this.projectPackConversionDataPayload,
      this.productId
    );
  }

  searchMaterial(searchData: any) {
    this.searchData = searchData;
    this.projectPackConversionDataPayload = this.productIngredientDataGridService.getPayload(
      this.searchData,
      this.sortColumnState,
      this.event
    );
    this.sharedFacade.clearSearch(false);
    this.projectFacade.getProductIngredientList(
      this.projectPackConversionDataPayload,
      this.productId
    );
  }

  sortChanged(sortColumnState: any) {
    this.sortColumnState = sortColumnState;
    this.projectPackConversionDataPayload = this.productIngredientDataGridService.getPayload(
      this.searchData,
      sortColumnState,
      this.event
    );
    this.sharedFacade.clearSearch(false);
    this.projectFacade.getProductIngredientList(
      this.projectPackConversionDataPayload,
      this.productId
    );
  }

  findNextRoute() {
    const currentProductId = this.productId; // Fetch this from route or localStorage
    const activeIndex = this.menuDataForRouting.findIndex(
      (x: any) => x.description === this.activatedRoute && x.productId === currentProductId
    );

    // Find the next index and route
    const nextIndex = activeIndex + 1;
    if (
      nextIndex < this.menuDataForRouting.length &&
      this.menuDataForRouting[nextIndex].productId === currentProductId
    ) {
      this.nextRouteName = this.menuDataForRouting[nextIndex].description;
    } else {
      this.nextRouteName = 'chart-at-glance'; // No next route
      this.activeProductProjectId = localStorage.getItem('productConfigId');
    }

    if (!this.nextRouteName) this.backBtnLabel = backToDashboardStr;
    else this.backBtnLabel = 'Next';
  }

  async nextRoute() {
    this.findNextRoute();

    if (!this.nextRouteName) {
      this.router.navigate(['/dashboard']);
      return;
    }

    if (this.nextRouteName === 'chart-at-glance') {
      const activeProductProjectId: any = localStorage.getItem('productConfigId');
      const reportFormData: any = await this.reportsService.checkReportFromDataForProduct(
        activeProductProjectId
      );
      if (reportFormData && reportFormData.data) {
        const { item1, item2 } = reportFormData.data;

        if (item1 === false) {
          if (item2) {
            await this.swalService.confirmNew(
              'Report validation',
              item2,
              undefined,
              undefined,
              true
            );
          }
          return;
        } else {
          this.sharedService.accessProductSideBarData('charts');
          this.router.navigate([
            `projects/product-configuration/${this.productConfigId}/chart-at-glance`,
          ]);
          return;
        }
      }
    }
    const encryptedValue = customEncrypt(this.productId);
    this.router.navigate(
      [
        `projects/product-configuration/${customEncode(btoa(this.productConfigId))}/${
          this.nextRouteName
        }`,
      ],
      { queryParams: { param: encryptedValue } }
    );
  }

  backRoute() {
    const encryptedValue = customEncrypt(this.productId);
    this.router.navigate(
      [`projects/product-configuration/${customEncode(btoa(this.productConfigId))}/configurations`],
      { queryParams: { param: encryptedValue } }
    );
  }
}
